import { Routes, Route, Navigate, HashRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import './App.scss';
import { Dashboard } from './pages/Dashboard';
import { FrequentUpdates } from './pages/FrequentUpdates';
import { TypesenseSync } from './pages/TypesenseSync';

function App() {
  return (
    <HashRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/frequent-updates"
            element={
              <ProtectedRoute>
                <FrequentUpdates />
              </ProtectedRoute>
            }
          />

          <Route
            path="/typesense-sync"
            element={
              <ProtectedRoute>
                <TypesenseSync />
              </ProtectedRoute>
            }
          />

          {/* Catch all route for 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </HashRouter>
  );
}

export default App;
